<template lang="pug">
    .concurs_icebreaker(ref="concurs_icebreaker")
        .icebreaker(v-if="!isMobileDevice")
            template(v-for="detail in details")
                .detail_icon(:class="['n'+detail.name]")
                .detail_info
                    .inner
                        .img
                            .img_inner(:style="{backgroundImage: 'url('+detail.img+')'}")
                        .text
                            h3(v-html="detail.h3")
                            p(v-html="detail.p")
        .showSlider(v-if="!isMobileDevice" @click="$store.commit('openPopup', 'icebreakerSlider')")

        .content
            h2 Атомный ледокол<br> «50 лет победы»
            IcebreakerShipMobile(v-if="isMobileDevice"
                :details="details"
                :slides="slides"
                :openSliderAndGallery="openSliderAndGallery"
                @closeSliderAndGallery="closeSliderAndGallery")
            template(v-if="!openSliderAndGallery")
                p На сегодняшний день крупнейший в мире атомоход. На судне применена ложкообразная форма носовой оконечности.На ледоколе установлена цифровая система автоматического управления нового поколения. Модернизирован комплекс средств биологической защиты атомной энергетической установки, прошедший переосвидетельствование в соответствии с современными требованиями Ростехнадзора. На «50 лет Победы» создан экологический отсек, оснащённый новейшим оборудованием для сбора и утилизации всех продуктов жизнедеятельности судна.
                .know_more(v-if="isMobileDevice" @click="openSliderAndGallery=true") Узнать больше
                .back(v-if="isMobileDevice" @click="$emit('goToIntro')")

        transition(name="showSlider")
            IcebreakerSlider(v-if="!isMobileDevice && popup==='icebreakerSlider'" :slides="slides")
</template>

<script>
    import IcebreakerShipMobile from '@/components/concurs/IcebreakerShipMobile'
    import IcebreakerSlider from '@/components/concurs/IcebreakerSlider'

    export default {
        name: "Icebreaker",
        data: () => ({
            openSliderAndGallery: false,
            details: [
                /*{
                    name: 'zub',
                    img: require('@/assets/img/concurs/ditails/zub.jpg'),
                    h3: 'ограничитель «ледовый зуб»',
                    p: '«50 лет Победы» – не туристское судно, но в то же время подготовлено для пассажирских круизов. Просторные и удобные каюты, ресторан, музыкальный и смотровой салоны, библиотека, лекционный зал, бар, спортзал, сауна предлагают комфортное размещение и возможности отдохнуть и расслабиться в свободное время.'
                },*/
            ],
            slides: [
                {
                    title: 'Атомный ледокол «50 лет Победы», проводка каравана.<br>> Фото: Дмитрий Лобусов/Атомфлот',
                    img: require('@/assets/img/concurs/slides/slide1.jpg'),
                    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
                },
            ]
        }),
        computed: {
            popup() {
                return this.$store.state.popup
            },
            isMobileDevice() {
                return this.$store.state.isMobileDevice
            },
        },
        methods: {
            closeSliderAndGallery() {
                this.$refs.concurs_icebreaker.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
                this.openSliderAndGallery = false
            },
            async getDetails() {
                try{
                    let {data} = await this.axios.get('?ACTION=getIcePoints');
                    this.details = data.DATA.map(el=>({
                        name: el.ID,
                        img: el.PREVIEW_PICTURE,
                        h3: el.NAME,
                        p: el.PREVIEW_TEXT
                    }))
                }catch (e) {
                    console.error(e)
                }
            },
            async getSlides() {
                try{
                    let {data} = await this.axios.get('?ACTION=getIceSlider');
                    this.slides = data.DATA.map(el=>({
                        title: el.NAME,
                        img: el.PREVIEW_PICTURE,
                        text: el.PREVIEW_TEXT
                    }))

                    console.log(data);
                }catch (e) {
                    console.error(e)
                }
            }
        },
        mounted() {
            this.getDetails();
            this.getSlides();
        },
        components: {
            IcebreakerSlider,
            IcebreakerShipMobile,
        },
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .concurs_icebreaker {
        display: flex;
        align-items: flex-end;
        background: url(../../assets/img/concurs/icebreaker_bg.jpg) no-repeat center center / cover;

        &:not(.show) {
            .icebreaker, .content h2, .content p, .showSlider {
                transition: 0s .8s;
            }

            .icebreaker {
                transform: scale(0.92);
                opacity: 0;
            }

            .content {
                h2 {
                    transform: translateY(10%);
                    opacity: 0;
                }

                p {
                    transform: translateY(10%);
                    opacity: 0;
                }
            }

            .showSlider {
                transform: translateX(100%);
            }
        }

        &.show {
            .icebreaker {
                transition: 1s .5s;
            }

            .content {
                h2 {
                    transition: .8s 1s;
                }

                p {
                    transition: .8s 1.2s;
                }
            }

            .showSlider {
                transition: .4s 1.5s;
            }
        }


        .icebreaker {
            position: relative;
            width: 100%;
            height: 100%;
            transform-origin: 80% 50%;
            background: url(../../assets/img/concurs/icebreaker.png) no-repeat left bottom 2.8vw / 94.5% auto;

            .detail_icon {
                position: absolute;
                width: 1.6rem;
                height: 1.6rem;
                border-radius: 2px;
                background: url(../../assets/img/concurs/icebreakerDetail_icon.png) no-repeat center center / 57% auto $blue;
                cursor: pointer;

                &:hover + .detail_info {
                    opacity: 1;
                }

                &.n87 {
                    left: 29vw;
                    bottom: 8vw;
                }
                &.n88 {
                    left: 40vw;
                    bottom: 14vw;
                }
                &.n89 {
                    left: 56vw;
                    bottom: 17vw;
                }
                &.n90 {
                    left: 69vw;
                    bottom: 21.5vw;
                }
                &.n91 {
                    left: 49.9vw;
                    bottom: 30.1vw;
                }
                &.n92 {
                    left: 64vw;
                    bottom: 26vw;
                }
                &.n93 {
                    left: 75vw;
                    bottom: 26vw;
                }
                &.n94 {
                    left: 56.2vw;
                    bottom: 38vw;
                }
                &.n95 {
                    left: 72vw;
                    bottom: 30vw;
                }
            }

            .detail_info {
                position: absolute;
                right: 7.7vw;
                bottom: 9.6vh;
                width: 32vw;
                color: #fff;
                transform: skewX(-18deg);
                transform-origin: 0 100%;
                opacity: 0;
                pointer-events: none;
                transition: opacity .3s;

                &:before, &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                }

                &:before {
                    background: #00bbee;
                    transform: translate(0.4vw, 0.3vw);
                }

                &:after {
                    background: $blue;
                }

                .inner {
                    position: relative;
                    z-index: 1;
                    display: flex;
                    transform: skewX(18deg);
                    transform-origin: 0 100%;
                }

                .img {
                    min-width: 32%;
                    transform: skewX(-18deg);
                    transform-origin: 0 100%;
                    overflow: hidden;

                    .img_inner {
                        width: 120%;
                        height: 100%;
                        background: no-repeat center center / cover;
                        transform: skewX(18deg);
                        transform-origin: 0 100%;
                    }

                }

                .text {
                    padding: 1vw 0 1vw 3vw;
                }

                h3 {
                    margin-bottom: 0.3vw;
                    font-size: 1.59vw;
                    font-weight: bold;
                }

                p {
                    font-family: 'Fira Sans Extra Condensed', sans-serif;
                    font-size: 0.77vw;
                    line-height: 1.4;
                }
            }

        }

        .content {
            position: absolute;
            top: 20.1vh;
            left: 6.2vw;
            max-width: 29vw;
            color: $blue;

            h2 {
                margin-bottom: 1.5vh;
                font-size: 4.36vw;
                line-height: 0.85;
                font-weight: bold;
            }

            p {
                font-family: 'Fira Sans Extra Condensed', sans-serif;
                font-size: 0.89vw;
                line-height: 1.3;
            }
        }

        .showSlider {
            position: absolute;
            top: 44%;
            right: 0;
            width: 3.2rem;
            height: 6.1rem;
            background: url(../../assets/img/concurs/showPhotos_icon.png) no-repeat right center / contain;
            cursor: pointer;
        }
    }


    .showSlider-enter {
        .left, .right {
            opacity: 0;
        }

        .swiper-container {
            opacity: 0;
            transform: translateY(2vh);
        }

        .bg {
            .left {
                transform: skewX(-28.4deg) translate3d(0, -50%, 0);
            }

            .right {
                transform: skewX(-28.4deg) translate3d(0, 50%, 0);
            }
        }
    }

    .showSlider-enter-active {
        transition: 1s;

        .left, .right {
            transition: .5s;
        }

        .swiper-container {
            transition: .7s .3s;
        }
    }

    .showSlider-leave-active {
        transition: .7s;

        .swiper-container {
            transition: .5s;
            opacity: 0;
        }

        .left, .right {
            opacity: 0;
            transition: .5s .2s;
        }

        .bg {
            .left {
                transform: skewX(-28.4deg) translate3d(0, -50%, 0);
            }

            .right {
                transform: skewX(-28.4deg) translate3d(0, 50%, 0);
            }
        }
    }

    .mobile .concurs_icebreaker {
        align-items: flex-start;
        overflow: auto;

        .content {
            position: relative;
            top: initial;
            left: initial;
            max-width: 100vw;
            padding: 27vw 0 0;
            overflow: hidden;
            background: url(../../assets/img/concurs/icebreaker_bottom-mobile.png) no-repeat right bottom/ 102% auto;

            h2 {
                font-size: 12.7vw;
                line-height: 1.05;
                text-align: center;
            }

            p {
                padding: 6vw 4vw 8vw;
                font-size: 4vw;
                line-height: 1.34;
                text-align: center;
            }

            & > .back {
                position: absolute;
                top: 42%;
                left: 0;
                z-index: 1;
                width: 7vw;
                height: 18vw;
                background: url(../../assets/img/button_back.png) no-repeat left top/contain;
            }

            .know_more {
                position: relative;
                z-index: 1;
                display: block;
                width: 57vw;
                text-transform: uppercase;
                font-family: Pobeda, Arial;
                font-size: 4.3vmin;
                font-weight: bold;
                text-align: center;
                color: #fff;
                margin: 0 auto 12vw;
                padding: 3vmin 0 2.8vmin;
                white-space: nowrap;
                letter-spacing: 1px;

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: -22%;
                    z-index: -1;
                    background: url(../../assets/img/nav_concurs_bg.png) no-repeat center center / 100% 100%;
                }
            }
        }
    }
</style>
